import { render, staticRenderFns } from "./dialogEditForward.vue?vue&type=template&id=1ed6f5e1&scoped=true"
import script from "./dialogEditForward.vue?vue&type=script&lang=js"
export * from "./dialogEditForward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed6f5e1",
  null
  
)

export default component.exports